// LANGUAGE
export const ALLOW_LANG = ['en', 'es', 'it', 'de', 'fr'];

// SECTIONS
export const SECTION_FIELDS = 'fields';
export const SECTION_PARAMETERS = 'parameters';
export const SECTION_USERS = 'users';
export const SECTION_LITERALS = 'literals';
export const SECTION_WIDGETS = 'widgets';
export const SECTION_CUSTOM_EVENTS = 'customEvents';
export const SECTION_FORMS = 'forms';
export const SECTION_APIKEYS = 'apykeys';
export const SECTION_CRONS = 'crons';
export const SECTION_ROLES = 'roles';
export const SECTION_IMPORT = 'import';

// LIST
export const TYPE_LIST_SECTION = 'listSection';

// Custom Lists (hardcoded lists because they don't exist in Database)
export const CL_LOCALE = 'CustomListLocale';
export const CL_FIELD_TYPES = 'CustomListFieldTypes';
export const CL_LANGUAGES = 'CustomLanguages';
export const CL_SFM_TABS = 'CustomSfmTabs';
export const CL_FM_FUNCTIONS_ARG_TYPES = 'CustomFMFunctionsArgsTypes';

// Fuzzy Special cases
export const VL_TIPOS_IDIOMA = 'tblTiposIdioma';

// SANDBOX
export const SANDBOX_NO_CREATED = 'no created';
export const SANDBOX_PENDING = 'in progress';
export const SANDBOX_CREATED = 'created';
export const SANDBOX_DENIED = 'creation denied';
export const SANDBOX_ERROR = 'Error';
export const SANDBOX_READY = 'Ready';

// FIELDS
export const ENT_ACCOUNT = 'Empresas';
export const ENT_CONTACT = 'Contactos';
export const ENT_OPPORTUNITY = 'Expedientes';
export const ENT_ACTIVITY = 'Gestiones';
export const ENT_QUOTE = 'COferta';
export const ENT_CALENDAR = 'tblAgenda';
export const ENT_SALESORDER = 'tblSalesOrders';
export const ENT_PRODUCT = 'Productos';
export const ENT_VALUE_LIST = 'valuelist';
export const ENT_USERS = 'tblUsuarios';
export const FIELD_TYPE_STANDARD = 'standard';
export const FIELD_TYPE_EXTRA = 'extra';
export const FIELD_TYPE_TAB = 'tab';

// PERMISSIONS & PARAMETERS
export const TAB_PERMISSIONS = 'permissions';
export const TAB_PARAMETERS = 'parameters';

// USERS
export const TAB_U_HIERARCHY = 'tab_users_hierarchy';
export const TAB_U_TABLE = 'tab_users_table';
export const TAB_U_BRANCH = 'tab_users_branch';
export const TAB_U_PASSWORD = 'tab_users_password';
export const TAB_U_AUTHENTICATION = 'tab_users_authentication';
export const TAB_U_INFO = 'tab_user_info';
export const TAB_U_ROLES_PERMISSIONS = 'tab_user_roles_permissions';
export const TAB_U_SYNCHRO = 'tab_user_synchro';
export const TAB_U_AUDIT = 'tab_user_audit';

// API KEYS
export const TAB_A_APIKEYS = 'apiv4';
export const TAB_A_INTEGRATIONS = 'integrations';
export const TAB_A_SANDBOX = 'sandbox';
export const TAB_A_FTP = 'ftp';
export const TAB_A_MAPS = 'maps';

// WIDGETS
export const TAB_W_ACCOUNT = '2';
export const TAB_W_CONTACT = '3';
export const TAB_W_OPPORTUNITY = '1';
export const TAB_W_SFM = '54';
// custom widget ID created by new cfm
export const OLD_CUSTOM_WIDGET_ID = 8;
export const CUSTOM_WIDGET_ID = 100;
export const WIDGET_TYPE_SFM = 54;
// special cases
export const VL_TIPOS_OBJETOS = 'tblTiposObjetos';

// CUSTOM FUNCTIONS
export const TAB_EVENTS = 'tab_events';
export const TAB_FUNCTIONS = 'tab_functions';

// CRUD
export const CRUD_TYPE_ADD = 1;
export const CRUD_TYPE_EDIT = 2;
export const CRUD_TYPE_DUPLICATE = 3;

// ID SETUP ROLES
export const SETUP_ROL_GOD = 1;
export const SETUP_ROL_IMPLEMENTATOR = 2;
export const SETUP_ROL_PROJECT_MANAGER = 3;
export const SETUP_ROL_CUSTOMER_SUCCESS_MANAGER = 4;
export const SETUP_ROL_TECHNICAL = 5;
export const SETUP_ROL_PARTNER_ADMIN = 6;
export const SETUP_ROL_PARTNER = 7;
export const SETUP_ROL_BUSINESS = 8;
export const SETUP_ROL_SMALL_BUSINESS = 9;

// PRODUCT CODES
export const SAGE_PRODUCT_CODES = {
    SAGE: 'sage_crm',
    SAGE50: 'sage50_crm',
    SAGE200: 'sage200_crm',
    SAGE50UK: 'sage50uk_crm',
    SAGE50FR: 'sage50fr_crm',
    SAGE100FR: 'sage100fr_crm',
};

export const PRODUCT_CODES = {
    BUSINESS: 'business',
    SMB: 'smb',
    5500: '5500',
    SOFTLAND: 'softland_crm',
    KITDIGITAL: 'kitdigital_crm',
    ...SAGE_PRODUCT_CODES,
};
